import _ from 'underscore';

export default class CloudFamily {
  JIRA_KEY: string;
  CONFLUENCE_KEY: string;
  ROLE_BASED_PRICING_PRODUCTS: string[];
  DEPRECATED: string[];
  JIRA_FAMILY: { family: string; primaryParent: any; products: any[]; };
  CONFLUENCE_FAMILY: { family: string; primaryParent: any; products: any[]; };

  constructor() {
    this.JIRA_KEY = 'jira-software.ondemand';
    this.CONFLUENCE_KEY = 'confluence.ondemand';

    this.ROLE_BASED_PRICING_PRODUCTS = ['jira-servicedesk.ondemand', 'com.atlassian.servicedesk.ondemand'];

    this.DEPRECATED = [
      'bamboo.ondemand',
      'com.atlassian.bitbucket',
      'com.atlassian.hipchat'
    ];

    this.JIRA_FAMILY = {
      family: 'jira',
      primaryParent: this.JIRA_KEY,
      products: [
        this.JIRA_KEY,
        'jira-servicedesk.ondemand',
        'jira-core.ondemand',
        'com.radiantminds.roadmaps-jira.ondemand',
        'bonfire.jira.ondemand'
      ]
    };

    this.CONFLUENCE_FAMILY = {
      family: 'confluence',
      primaryParent: this.CONFLUENCE_KEY,
      products: [
        this.CONFLUENCE_KEY,
        'com.atlassian.confluence.plugins.confluence-questions.ondemand',
        'team.calendars.confluence.ondemand'
      ]
    };

  }

  getFamilies() {
    return [this.JIRA_FAMILY, this.CONFLUENCE_FAMILY];
  }

  getProductKeys() {
    return _.flatten(_.pluck(this.getFamilies(), 'products'));
  }

  getDeprecatedProductKeys() {
    return this.DEPRECATED;
  }

  getFamiliesPrimaryKey() {
    let primaryKeys: { [name: string]: any } = {};

    _.each(this.getFamilies(), (family) => {
      primaryKeys[family.family] = family.primaryParent;
    });

    return primaryKeys;
  }

  isParent(product) {
    return !!(product && product.parentKeys &&
      (_.isEmpty(product.parentKeys) || _.contains(product.parentKeys, 'atlassian.ondemand')));
  }

  getByKey(objects, key) {
    return _.findWhere(objects, {productKey: key});
  }

  hasKey(objects, key) {
    return !!this.getByKey(objects, key);
  }

  isRoleBasedProduct(product) {
    return _.include(this.ROLE_BASED_PRICING_PRODUCTS, product.productKey);
  }

}
